import type { EditorPlugin } from '../../types/aha-editor';
import {
  OrderedListComponentPlugin,
  UnorderedListComponentPlugin,
  CheckboxListComponentPlugin,
  ListKeydownHandlerPlugin,
  DefinitionListComponentPlugin,
} from './ListComponentsPlugin';
import ListItemPlugin from './ListItemPlugin';
import ListWrapUtils from './ListWrapUtils';
import * as ListUtils from './utils';

import {
  OrderedListMarkdownPlugin,
  UnorderedListMarkdownPlugin,
  CheckboxListMarkdownPlugin,
} from './ListMarkdownPlugin';
import ListNormalizationsPlugin from './ListNormalizationsPlugin';

const ListPlugin: EditorPlugin[] = [
  OrderedListMarkdownPlugin,
  UnorderedListMarkdownPlugin,
  CheckboxListMarkdownPlugin,
  UnorderedListComponentPlugin,
  OrderedListComponentPlugin,
  CheckboxListComponentPlugin,
  DefinitionListComponentPlugin,
  ListKeydownHandlerPlugin,
  ListItemPlugin,
  ListNormalizationsPlugin,
];

export const ListPlugins = {
  OrderedListMarkdownPlugin,
  UnorderedListMarkdownPlugin,
  CheckboxListMarkdownPlugin,
  UnorderedListComponentPlugin,
  OrderedListComponentPlugin,
  CheckboxListComponentPlugin,
  DefinitionListComponentPlugin,
  ListKeydownHandlerPlugin,
  ListItemPlugin,
  ListNormalizationsPlugin,
};

export const Utils = {
  ListWrap: ListWrapUtils,
  ...ListUtils,
};

export default ListPlugin;
